import jsCookie from 'js-cookie'
import changePrivinceCodeToCityCode from '@/plugins/changeCityCode'
import { isIOS, isHZWAPP, isRKHYAPP, isAndroid } from './device'
import { getLocation } from 'bs-sdk'

/**
 * 获取定位
 * H5取高德定位
 * app-webview内取jsbridge.getgps()
 * 非hzwapp采用的是高德定位服务AMap.Geolocation
 * @returns {{lat: string,lng: string,cityId,cityName,cityCode}}
 */
export async function getPosition(useCache = true) {
  const location = (await getLocation()) || {}
  return location
}

/**
 * 获取用户选择收货地址所在的定位
 * @returns {{cityCode,cityName,adcode,lat,lng}}
 */
export function getAppLocation() {
  let addr
  if (isIOS() && window.app && window.app.jsNavtiveSyncHandle) {
    const str = JSON.stringify({
      targetClass: 'KTemaiJsConfig',
      methodType: 1,
      methodName: 'getOverallAddress' || ''
    })
    addr = window.app.jsNavtiveSyncHandle(str)
  } else if (
    isAndroid() &&
    window.localjs &&
    window.localjs.invokeNativeSyncMethod
  ) {
    const str = JSON.stringify({
      targetClass: 'com.kidswant.component.h5.HZWJsHandler',
      methodType: '0',
      methodArgsTypes: 't,b',
      methodName: 'getGlobalAddress' || ''
    })
    addr = window.localjs.invokeNativeSyncMethod(str)
  }
  // console.log('获取用户选择收货地址所在的定位', addr)

  try {
    addr = JSON.parse(addr) || {}
    const {
      cityName: cityname,
      cityCode: citycode,
      districtCode: adcode,
      latitude: lat,
      longitude: lng
    } = addr
    return {
      ...addr,
      citycode,
      cityname,
      adcode,
      lat,
      lng
    }
  } catch (e) {
    return {}
  }
}
/**
 * 禁止授权的情况下，取cityCode
 */
export function getCityCodeInNoGPSAuthorization() {
  let cityCode
  if (isHZWAPP() || isRKHYAPP()) {
    cityCode = getAppLocation().cityCode
  } else {
    cityCode = jsCookie.get('groupcity')
  }
  if (!cityCode) {
    cityCode = jsCookie.get('citycode')
  }
  if (cityCode) {
    cityCode = changePrivinceCodeToCityCode(cityCode)
  }
  return cityCode || '320100'
}
